module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor14-4094c78c1649427c0d9dad106284c966.png";